// RxJs imports
import { Subject } from 'rxjs';
import * as i0 from "@angular/core";
export class BoardApprovalHelperService {
    constructor() {
        // As per Sandeep's discussion on 2024-11-08, loading panel message has custom text for Portfolio mode
        this._subjectLoading = new Subject();
    }
    onLoadingEvent() {
        return this._subjectLoading;
    }
    showLoading(loadingMessage = 'Loading...') {
        this._subjectLoading.next({ message: loadingMessage, showLoading: true });
    }
    hideLoading() {
        this._subjectLoading.next({ message: null, showLoading: false });
    }
}
BoardApprovalHelperService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function BoardApprovalHelperService_Factory() { return new BoardApprovalHelperService(); }, token: BoardApprovalHelperService, providedIn: "root" });
